import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // dark: true,
    themes: {
      dark: {
        primary: '#089dd9',
        //secondary: '#8c9eff',
        secondary: '#fec52e',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
      light: {
        primary: '#089dd9',
        //secondary: '#8c9eff',
        secondary: '#fec52e',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});
